<section class="spacer-pt-space spacer-pb-space">
    <div class="container">
        @for(Disclaimer of DisclaimerValue; track $index){
        <h2 class="text-18 mb-5 text-[#333333] font-inter-regular" [innerHtml]="Disclaimer.heading"></h2>
        <div class="text-14 remove-space-last text-[#666666] font-extralight" [innerHtml]="Disclaimer.description">
        </div>
        }
    </div>
</section>